import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimgs from "../../../assets/AIpromptEngLeftImg.png";
import rightimgs from "../../../assets/AIpromptEngRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
// import AIpromptEngBenefitsImg1 from "../../../assets/AIpromptEngBenefitsImg1.png";
// import AIpromptEngBenefitsImg2 from "../../../assets/AIpromptEngBenefitsImg2.png";
// import AIpromptEngBenefitsImg3 from "../../../assets/AIpromptEngBenefitsImg3.png";
// import AIpromptEngBenefitsImg4 from "../../../assets/AIpromptEngBenefitsImg4.png";
// import AIpromptEngBenefitsImg5 from "../../../assets/AIpromptEngBenefitsImg5.png";
// import AIpromptEngBenefitsImg6 from "../../../assets/AIpromptEngBenefitsImg6.png";
// import AIpromptEngBenefitsImg7 from "../../../assets/AIpromptEngBenefitsImg7.png";
// import AIpromptEngBenefitsImg8 from "../../../assets/AIpromptEngBenefitsImg8.png";
// import AIpromptEngBenefitsImg9 from "../../../assets/AIpromptEngBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
// import AIpromptEngFunActivitiesImg1 from "../../../assets/AIpromptEngFunActivitiesImg1.png";
// import AIpromptEngFunActivitiesImg2 from "../../../assets/AIpromptEngFunActivitiesImg2.png";
// import AIpromptEngFunActivitiesImg3 from "../../../assets/AIpromptEngFunActivitiesImg3.png";
// import AIpromptEngFunActivitiesImg4 from "../../../assets/AIpromptEngFunActivitiesImg4.png";
// import AIpromptEngFunActivitiesImg5 from "../../../assets/AIpromptEngFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

const AIpromptEngineering = () => {
  const AIpromptEngineeringpage = heroContent.AIpromptEngineeringpage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "16",
      classes: "8",
      description:
        "Prompt Engineering Basics -Learn to talk to AI better with clear, effective prompts and smarter instructions.",
    },
    {
      title: "Module 2",
      activities: "12",
      classes: "8",
      description:
        " Advanced Prompt Engineering - Master the art of crafting precise prompts and learn how AI understands language to get smarter, clearer responses.",
    },
  ];

  const benefitsData = [
    {
      title: "Master the Basics",
      description: "Learn how prompt engineering works.",
      icon: "Polymath-images/AIpromptEngBenefitsImg1.png",
    },
    {
      title: "Create Smart Prompts",
      description: "Design effective prompts for better AI answers.",
      icon: "Polymath-images/AIpromptEngBenefitsImg2.png",
    },
    {
      title: "Talk to AI Clearly",
      description: "Communicate with AI for accurate results.",
      icon: "Polymath-images/AIpromptEngBenefitsImg3.png",
    },
    {
      title: "Use in Real Life",
      description: "Apply skills in school, creativity & more.",
      icon: "Polymath-images/AIpromptEngBenefitsImg4.png",
    },
    {
      title: "Boost AI Accuracy",
      description: "Test and improve prompt quality.",
      icon: "Polymath-images/AIpromptEngBenefitsImg5.png",
    },
    {
      title: "Think Ethically",
      description: "Promote kindness and fairness in AI use.",
      icon: "Polymath-images/AIpromptEngBenefitsImg6.png",
    },
    {
      title: "Get Creative with AI",
      description: "Use AI for stories, art, and fun ideas.",
      icon: "Polymath-images/AIpromptEngBenefitsImg7.png",
    },
    {
      title: "Improve Everyday Tasks",
      description: "Let AI help with writing, planning & projects.",
      icon: "Polymath-images/AIpromptEngBenefitsImg8.png",
    },
    {
      title: "Be an AI Pro",
      description: "Build confidence in using AI responsibly.",
      icon: "Polymath-images/AIpromptEngBenefitsImg9.png",
    },
  ];
  const activitiesData = [
    {
      title: "Prompt Fixing Challenge",
      image: "Polymath-images/AIpromptEngFunActivitiesImg1.png",
    },
    {
      title: "Prompt vs Output Analysis",
      image: "Polymath-images/AIpromptEngFunActivitiesImg2.png",
    },
    {
      title: "Clear Prompt Writing",
      image: "Polymath-images/AIpromptEngFunActivitiesImg3.png",
    },
    {
      title: "AI Roleplay Exercise",
      image: "Polymath-images/AIpromptEngFunActivitiesImg4.png",
    },
    {
      title: "Ethical Prompting Discussion",
      image: "Polymath-images/AIpromptEngFunActivitiesImg5.png",
    },
  ];

  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
      leftImg={"Polymath-images/AIpromptEngLeftImg.png"}
      rightImg={'Polymath-images/AIpromptEngRightImg.png'}
      titlePart1="AI - Prompt Engineering"
      titlePart2="Course"
      description="Polymath-kids offer comprehensive online AI-Prompt Engineering course.The online classes' offers two modes-online 1:1 classes and online group classes with trained teachers having years of experience in Computer Sciences."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From AI - Prompt Engineering"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn AI - Prompt Engineering"
        subTitle="With 30+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default AIpromptEngineering;
